function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React, { useRef } from 'react';
import { Stack, Link, Flex, Box, IconButton, Icon, icons, chakra as C, TapTheme } from '@tapresearch/ui/components';
import { useDisclosure } from '@tapresearch/ui/hooks';
import { MobileSidebar } from './MobileSidebar';
import { AccountMenu } from './AccountMenu';
import { ProductMenu } from './ProductMenu';
import { OrganizationalContextBanner } from './OrganizationalContextBanner';
import { useBreakpoint } from 'Shared/Hooks';
import { NewToTapBanner } from './NewToTapBanner';
export var SiteNav = function(param) {
    var currentProduct = param.currentProduct, asset = param.asset, user = param.user, Sidebar = param.sidebar, sidebarProps = param.sidebarProps, _param_headerContent = param.headerContent, headerContent = _param_headerContent === void 0 ? null : _param_headerContent;
    var _useDisclosure = useDisclosure(), isOpen = _useDisclosure.isOpen, onOpen = _useDisclosure.onOpen, onClose = _useDisclosure.onClose;
    var triggerBtnRef = useRef();
    var isSm = useBreakpoint().isSm;
    var is_active = (user && user.organization_membership || {}).is_active;
    var customer = (user && user.organization || {}).customer;
    var isBannedCustomer = customer && customer.insights_moderation_status === asset.constants.INSIGHTS_MODERATION_STATUS_BANNED;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, Styles.NavWrapper, isSm && user && /*#__PURE__*/ React.createElement(Box, {
        w: "80px"
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 7,
            icon: icons.ai.OutlineMenu
        }),
        ref: triggerBtnRef,
        size: "lg",
        onClick: onOpen,
        variant: "ghost",
        color: "black"
    }), /*#__PURE__*/ React.createElement(MobileSidebar, {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        triggerBtnRef: triggerBtnRef
    }, /*#__PURE__*/ React.createElement(Sidebar, _object_spread({
        isMobile: isSm
    }, sidebarProps)))), /*#__PURE__*/ React.createElement(Flex, {
        justify: isSm ? 'center' : 'flex-start',
        flexGrow: !headerContent ? 1 : 0,
        minW: "160px"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: user ? "/organizations/".concat(user.organization.identifier, "/dashboard") : '/'
    }, /*#__PURE__*/ React.createElement(C.img, {
        h: isSm ? 10 : 12,
        src: asset.logo_dark
    }))), !!headerContent && /*#__PURE__*/ React.createElement(Flex, {
        minW: "530px",
        flexGrow: 1,
        pr: 4
    }, headerContent), user && /*#__PURE__*/ React.createElement(Flex, Styles.RightNav, is_active && !isBannedCustomer && /*#__PURE__*/ React.createElement(ProductMenu, {
        currentProduct: currentProduct,
        isMobile: isSm,
        asset: asset,
        user: user
    }), user && /*#__PURE__*/ React.createElement(AccountMenu, {
        user: user,
        asset: asset
    }))), /*#__PURE__*/ React.createElement(OrganizationalContextBanner, {
        user: user
    }), !user && /*#__PURE__*/ React.createElement(NewToTapBanner, null));
};
export var Styles = {
    NavWrapper: {
        h: 20,
        px: {
            base: 5,
            md: 8
        },
        direction: 'row',
        bg: 'white',
        boxShadow: 'md',
        zIndex: 3,
        position: 'relative',
        alignItems: 'center',
        fontFamily: "'Nunito Sans', sans-serif !important",
        sx: {
            'h1, h2, h3, h4': {
                fontFamily: "'Nunito Sans', sans-serif !important"
            }
        }
    },
    RightNav: {
        align: 'center'
    },
    NavButton: {
        py: 2,
        boxShadow: 'none',
        mr: 3,
        variant: 'ghost',
        color: 'gray.600',
        bg: 'none',
        _hover: {
            bg: TapTheme.fn.rgba(TapTheme.colors.blue[500], 0.13)
        },
        _active: {
            color: 'blue.500',
            bg: TapTheme.fn.rgba(TapTheme.colors.blue[500], 0.05)
        }
    },
    NavButtonProfile: {
        w: '50px',
        py: 2,
        fontSize: 'lg',
        fontWeight: 'extrabold',
        px: 0
    }
};
